//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import SearchIcon from '@material-ui/icons/Search';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { PATH_HOME } from '../../system/constants';
import { BASE_URL } from '../../common/constants';
// import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
// import { isOnPage } from '../../system/helpers/systemHelper';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import Logo from '../../system/Logo';
import LogoSm from '../../system/LogoSm';
import AfitdBox from '../../common/elemental/AfitdBox';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

// const alpha = () => {};
//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const drawerWidth = '100%';
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        topNavContainer: {
            overflow: 'hidden',
            overflowX: 'hidden',
            paddingRight: '64px',
            background: '#FAFAFC',
            width: '100%',
            height: '80px',
            borderBottom: '1px solid #F0F2F6',
            [theme.breakpoints.down('sm')]: { paddingRight: 0 },
        },
        // topNavLeft: { [theme.breakpoints.down('sm')]: { borderBottom: '1px solid #F0F2F6', height: 80 } },
        topNavRight: { height: '100%' },
        appLogoContainer: {
            // width: '368px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            [theme.breakpoints.up('xl')]: { width: '368px' },
            [theme.breakpoints.down('sm')]: { borderBottom: '1px solid #F0F2F6', height: 80 },
        },
        // appLogo: { width: 165 },
        topNavRightContainer: {
            background: '#FAFAFC',
            width: '100%',
            height: '80px',
            borderBottom: '1px solid #F0F2F6',
            display: 'flex',
            flexDirection: 'row',
        },

        // leftContainer: {
        //     width: '368px',
        //     display: 'flex',
        //     alignItems: 'center',
        //     justifyContent: 'center',
        // },
        // rightContainer: {
        //     display: 'flex',
        //     flexDirection: 'row',
        // },

        // drawer style
        root: {
            display: 'flex',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        // drawerPaper: {
        //     width: drawerWidth,
        //     marginTop: 78,
        //     background: 'white',
        //     borderTop: '1px solid #F0F2F6',
        // },
        // drawerHeader: {
        //     display: 'flex',
        //     alignItems: 'center',
        //     padding: theme.spacing(0, 1),
        //     // necessary for content to be below app bar
        //     ...theme.mixins.toolbar,
        //     justifyContent: 'flex-end',
        // },
        logoDrawerContainer: {
            display: 'flex',
            alignItems: 'center',
            // justifyContent: 'space-evenly',
            height: '100%',
            alignContent: 'center',
            marginLeft: 38,
            [theme.breakpoints.down('sm')]: { marginLeft: 15 },
        },
        // logoDrawerCloseContainer: {
        //     display: 'flex',
        //     justifyContent: 'space-between',
        //     alignItems: 'center',
        //     height: '100%',
        //     alignContent: 'center',
        //     marginLeft: 58,
        //     [theme.breakpoints.down('sm')]: { marginLeft: 10 },
        // },
        drawerIconContainer: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 12 },
        // topNavBottomContainer: {
        //     background: '#FAFAFC',
        //     width: '100%',
        //     height: '40px',
        //     borderBottom: '1px solid #F0F2F6',
        //     display: 'flex',
        //     flexDirection: 'row',
        //     [theme.breakpoints.down('sm')]: { justifyContent: 'center', alignItems: 'center' },
        // },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        // props,
        classes,
        // appContext,
        handleClickLogo,
        // handleClickProfilePic,
        // handleClickPopoverProfilePic,
        // history,
        // setPendingAccountSetupMessageDialogOpen,
        // location,
    } = params;

    const defns = {
        topNavContainer: { container: true },
        topNavLeft: { item: true, lg: 3, md: 3, sm: 3, xs: 3 },
        topNavRight: { item: true, lg: 9, md: 9, sm: 9, xs: 9 },
        // topNavBottomRight: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        // appLogoContainer: { onClick: handleClickLogo },
        appLogoHomeLink: { onClick: handleClickLogo },
        // dashboardButton: {
        //     // onClick: handleClickButton.bind(null, history, PATH_DASHBOARD),
        //     label: 'My Dashboard',
        // },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const TopNavBlank = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const appContext = useContext(AppContext);

    // const layoutContext = useContext(LayoutContext);
    const history = useHistory();
    // const location = useLocation();

    const theme = useTheme();
    // const xlMatchesUp = useMediaQuery(theme.breakpoints.up('xl'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));
    // END OF temp switch user

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // drawer state and handler
    const [openDrawer, setOpenDrawer] = React.useState(false);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // ? closing Drawer if switch between mobile/Tab to desktop view
    useEffect(() => {
        if (!mdMatches && !smMatches) setOpenDrawer(false);
    }, [smMatches, mdMatches]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickLogo = useCallback(() => {
        history.push(`${BASE_URL}${PATH_HOME}`);
    }, [history]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    if (props.isHidden) return null;
    const defns = getDefns({
        props,
        classes,
        // appContext,
        handleClickLogo,
        // handleClickProfilePic,
        // handleClickPopoverProfilePic,
        // history,
        // setPendingAccountSetupMessageDialogOpen,
        // location,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.topNavContainer}>
            <Grid {...defns.topNavLeft}>
                {mdMatches ? null : (
                    <AfitdBox {...defns.appLogoContainer}>
                        <span {...defns.appLogoHomeLink}>
                            <Logo {...defns.appLogo} />
                        </span>
                    </AfitdBox>
                )}
                {mdMatches ? (
                    openDrawer ? (
                        /* ------------------ 0 - 1023 (drawer opened) ------------------ */
                        <Grid {...defns.logoDrawerContainer}>
                            <div {...defns.drawerIconContainer}>{/* <CloseIcon onClick={handleDrawerClose} {...defns.closeBarIcon} /> */}</div>

                            <div {...defns.appLogoHomeLink}>
                                <LogoSm {...defns.appLogo} />
                            </div>
                        </Grid>
                    ) : (
                        /* ------------------ 0 - 1023 (drawer closed) ------------------ */
                        <Grid {...defns.logoDrawerContainer}>
                            <div {...defns.drawerIconContainer}>{/* <MenuIcon onClick={handleDrawerOpen} {...defns.menuBarIcon} /> */}</div>

                            <div {...defns.appLogoHomeLink}>
                                <LogoSm {...defns.appLogo} />
                            </div>
                        </Grid>
                    )
                ) : null}
            </Grid>
            <Grid {...defns.topNavRight}>
                <div {...defns.topNavRightContainer}></div>
            </Grid>

            {/* ================== bottom navbar for sm down ================== */}

            {/* {smMatches ? (
                <Grid {...defns.topNavBottomRight}>
                    <div {...defns.topNavBottomContainer}>
                        <AfitdBox>
                            <TopNavButtonBottom {...defns.dashboardButton} />
                        </AfitdBox>
                    </div>
                </Grid>
            ) : null} */}
            {/* ================== Drawer Section ================== */}
            {mdMatches && (
                /* ------------------ below 768 ------------------ */
                <div className={classes.root}>
                    <CssBaseline />
                    <AppBar position="fixed"></AppBar>
                </div>
            )}
        </Grid>
    );
};

export default TopNavBlank;
